import Links from '../components/Links';
import AddContactBtn from '../components/AddContactBtn';
import ShareLinks from '../components/ShareLinks';
import Divider from '../components/Divider';
import SlideshowGallery from '../components/SlideshowGallery';
import About from '../components/About';
import VideoPlayer from '../components/VideoPlayer';
import GoogleMap from '../components/GoogleMap';

const HomeScreen = ({ data }) => {
 return (
  <div>
   <Links data={data} />
   <AddContactBtn addContact={data.addContact} />
   <ShareLinks data={data} />
   <Divider data={data} />
   <SlideshowGallery data={data} />
   <Divider />
   <About />
   <Divider />
   <VideoPlayer data={data} />
   <Divider />
   <GoogleMap />
   <Divider />
  </div>
 );
};

export default HomeScreen;
